import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Grid} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {
  isLocationInfrastructureInventoryType,
  isVacantLandInventoryType,
  getOptionText,
} from 'go/components/dynamic/modules/projectSiteInventory/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import Tooltip from 'app-ui-componentlibrary/dist/componentLibrary/layout/Tooltip';
import {formatLatitude, formatLongitude} from 'common/utils';
import {CountyDropdown} from 'go/components/dynamic/modules/projectSiteInventory/sections/subSections/CountyDropdown';

const defaultSelected = {
  text: 'Select',
  value: null,
  key: 'select-default',
};

export class LocationInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openLatitudeModal: false,
      openLongitudeModal: false,
    };
  }

  confirmAction = async (action) => {
    const locationLatitudePath = 'location.latitude';
    const locationLongitudePath = 'location.longitude';

    const latitude = _.get(this.props.inventoryItem, locationLatitudePath);
    const longitude = _.get(this.props.inventoryItem, locationLongitudePath);

    let newValue;

    if (action === 'latitude') {
      newValue = formatLatitude(latitude);
      await this.props.handleFormattedValue(locationLatitudePath, newValue);
      this.props.saveValue(locationLatitudePath, newValue);
    } else if (action === 'longitude') {
      newValue = formatLongitude(longitude);
      await this.props.handleFormattedValue(locationLongitudePath, newValue);
      this.props.saveValue(locationLongitudePath, newValue);
    }

    this.setState({openLatitudeModal: false, openLongitudeModal: false});
  };

  handleBlurLatitude = (e) => {
    const value = e.target.value;
    var strippedLength = this.strippedInputLength(value);
    if (strippedLength !== 9) {
      this.setState({openLatitudeModal: true});
      this.props.handleBlur(e);
    } else {
      const newValue = formatLatitude(value);
      this.props.handleFormattedValue('location.latitude', newValue);
      this.props.saveValue('location.latitude', newValue);
    }
  };

  handleBlurLongitude = (e) => {
    const value = e.target.value;
    var strippedLength = this.strippedInputLength(value);
    if (strippedLength !== 10) {
      this.setState({openLongitudeModal: true});
      this.props.handleBlur(e);
    } else {
      const newValue = formatLongitude(value);
      this.props.handleFormattedValue('location.longitude', newValue);
      this.props.saveValue('location.longitude', newValue);
    }
  };

  strippedInputLength = (input) => {
    return input.replace(/-/, '').length;
  };

  render() {
    const {displayType, locationType, options, inventoryItem} = this.props;
    const isInfrastructure = isLocationInfrastructureInventoryType(locationType);

    if (_.isEmpty(inventoryItem) || _.isEmpty(_.get(inventoryItem, 'location')))
      return <p>No data available</p>;

    const {location} = inventoryItem;
    const isVacantLand = isVacantLandInventoryType(locationType) ? true : false;
    return (
      <div id="location-information">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="location-address1">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Address line 1{' '}
                      <span>{isInfrastructure || isVacantLand ? 'Optional' : null}</span>
                    </p>
                    {location.addr1}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="location-address1-control"
                      label="Address line 1"
                      optional={isInfrastructure || isVacantLand}
                      title={`${
                        isInfrastructure ? 'Optional' : 'Required'
                      }: Address line 1`}
                      name="location.addr1"
                      value={location.addr1}
                      maxLength={151}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('location.addr1')}
                      errorMessages={this.props.getErrorMessage(
                        'location.addr1',
                        'Address 1'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="location-address2">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Address line 2 <span>(Optional)</span>
                    </p>
                    {location.addr2}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="location-address2-control"
                      label="Address line 2"
                      optional={true}
                      title="Optional: Address line 2"
                      name="location.addr2"
                      value={location.addr2}
                      maxLength={151}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('location.addr2')}
                      errorMessages={this.props.getErrorMessage(
                        'location.addr2',
                        'Address 2'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="location-city">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">City</p>
                    {location.city}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="location-city-control"
                      label="City"
                      title="Required: City"
                      name="location.city"
                      value={location.city}
                      maxLength={51}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('location.city')}
                      errorMessages={this.props.getErrorMessage('location.city', 'City')}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="location-state">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">State</p>
                    {getOptionText(_.get(options, 'usStates', []), location.state)}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    {options && (
                      <InlineSelect
                        id="location-state-control"
                        label="State"
                        options={[defaultSelected, ...options.usStates]}
                        name="location.state"
                        aria-label="Required: State"
                        value={location.state}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError('location.state')}
                        errorMessages={this.props.getErrorMessage(
                          'location.state',
                          'State'
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          {location.state && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <CountyDropdown
                  inventoryItem={this.props.inventoryItem}
                  displayType={displayType}
                  id="location-county-control"
                  label="County"
                  ariaLabel="Required: County"
                  name="location.county"
                  value={location.county}
                  handleChange={this.props.handleChange}
                  saveValue={this.props.saveValue}
                  handleBlur={this.props.handleBlur}
                  displayError={this.props.displayError}
                  getErrorMessage={this.props.getErrorMessage}
                />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="zip-code">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Zip code <span>{isInfrastructure ? 'Optional' : null}</span>
                    </p>
                    {location.zip}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      maxLength={5}
                      id="location-zip-control"
                      label="Zip code"
                      optional={isInfrastructure}
                      aria-label={`${
                        isInfrastructure ? 'Optional' : 'Required'
                      }: Zip code`}
                      name="location.zip"
                      value={location.zip}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('location.zip')}
                      errorMessages={this.props.getErrorMessage(
                        'location.zip',
                        'Zip code'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="location-latitude">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">Latitude</p>
                    {location.latitude}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <Tooltip
                      htmlContent={''}
                      label={true}
                      input="location-latitude-control"
                      popup={
                        ('Popup',
                        {
                          link: 'Latitude',
                          text:
                            '<p>Valid range is -18.000000 to +72.000000 where + is for North and - is for South.</p><p>Data entry requires a ‘-‘ entered for each negative entry. A  ‘+’  sign is not required before positive entries.</p>',
                          style: {
                            borderRadius: 0,
                            opacity: 1,
                            padding: '2em',
                          },
                        })
                      }
                    ></Tooltip>
                    <FemaGoModal
                      parseHtml="true"
                      size="tiny"
                      type="alert"
                      title="Format latitude"
                      open={this.state.openLatitudeModal}
                      buttonText="Confirm"
                      confirmAction={() => {
                        this.confirmAction('latitude');
                      }}
                      cancelAction={() => {
                        this.setState({openLatitudeModal: false});
                      }}
                    >
                      Do you want to convert your entry to XX.xxxxxx format?
                    </FemaGoModal>
                    <TextBoxField
                      id="location-latitude-control"
                      title="Required: Latitude"
                      name="location.latitude"
                      value={location.latitude}
                      maxLength={10}
                      handleChange={this.props.handleChangeNumerical}
                      handleBlur={(e) => {
                        this.handleBlurLatitude(e);
                      }}
                      onKeyDown={(e) => {
                        const errors = _.get(this.props.inventoryItem, 'errors');
                        _.map(errors, (err) => {
                          const path = _.get(err, 'path');
                          if (path === 'location.latitude' && e.keyCode === 9) {
                            e.preventDefault();
                            this.handleBlurLatitude(e);
                          }
                        });
                      }}
                      displayError={this.props.displayError('location.latitude')}
                      errorMessages={this.props.getErrorMessage(
                        'location.latitude',
                        'Latitude'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="location-longitude">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">Longitude</p>
                    {location.longitude}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <Tooltip
                      htmlContent={''}
                      label={true}
                      input="location-longitude-control"
                      popup={
                        ('Popup',
                        {
                          link: 'Longitude',
                          text:
                            '<p>Valid range is -064.000000 to -180.000000 and 142.000000 to 180.000000 where + is for East and - is for West.</p><p>Data entry requires a ‘-‘ entered for each negative entry. A  ‘+’  sign is not required before positive entries.</p>',
                          style: {
                            borderRadius: 0,
                            opacity: 1,
                            padding: '2em',
                          },
                        })
                      }
                    ></Tooltip>
                    <FemaGoModal
                      parseHtml="true"
                      size="tiny"
                      type="alert"
                      title="Format longitude"
                      open={this.state.openLongitudeModal}
                      buttonText="Confirm"
                      confirmAction={() => {
                        this.confirmAction('longitude');
                      }}
                      cancelAction={() => {
                        this.setState({openLongitudeModal: false});
                      }}
                    >
                      Do you want to convert your entry to XXX.xxxxxx format?
                    </FemaGoModal>
                    <TextBoxField
                      id="location-longitude-control"
                      title="Required: Longitude"
                      name="location.longitude"
                      value={location.longitude}
                      maxLength={11}
                      handleChange={this.props.handleChangeNumerical}
                      handleBlur={(e) => {
                        this.handleBlurLongitude(e);
                      }}
                      onKeyDown={(e) => {
                        const errors = _.get(this.props.inventoryItem, 'errors');
                        _.map(errors, (err) => {
                          const path = _.get(err, 'path');
                          if (path === 'location.longitude' && e.keyCode === 9) {
                            e.preventDefault();
                            this.handleBlurLongitude(e);
                          }
                        });
                      }}
                      displayError={this.props.displayError('location.longitude')}
                      errorMessages={this.props.getErrorMessage(
                        'location.longitude',
                        'Longitude'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    inventoryItem: state.locationSiteData.inventoryItem,
  };
};

export default connect(mapStateToProps, null)(LocationInformation);
